<script>
const getDescendantProp = (obj, desc) => {
    let arr = desc.split('.');
    while (arr.length) {
        obj = obj[arr.shift()];
    }
    return obj;
};
const setDescendantProp = (obj, desc, val) => {
    let arr = desc.split('.');
    while (arr.length > 1) {
        obj = obj[arr.shift()];
    }
    return obj[arr[0]] = val;
};
const handleInput = (vnode, range, e) => {
    let target = e.target;
    let min = parseInt(getDescendantProp(vnode.context, range.min), 10);
    let max = parseInt(getDescendantProp(vnode.context, range.max), 10);
    let isA = target.id[target.id.length - 1] === 'a';
    let isValid = true;

    if (isA) {
        if (min > max) {
            setDescendantProp(vnode.context, range.min, max);
            isValid = false;
        }
    } else {
        if (max < min) {
            setDescendantProp(vnode.context, range.max, min);
            isValid = false;
        }
    }
    if (isValid) {
        target.parentNode.style.setProperty(`--${target.id[target.id.length - 1]}`, + target.value);
    }
};
export default {
    inserted(el, binding, vnode) {
        el.addEventListener('input', handleInput.bind(null, vnode, binding.value), false);
    },
    unbind(el) {
        el.removeEventListener('input', handleInput);
    }
};
</script>



// WEBPACK FOOTER //
// resources/components/vue-directives/range.vue